import { css } from 'lit'

export default css`
    .container > * {
        margin-bottom: 32px;
    }

    .and-condition {
        padding-left: 32px;
    }

    zaptic-dynamic-condition {
        position: relative;
        margin: 16px;
    }

    zaptic-dynamic-condition:not(:only-child)::after {
        content: '';
        position: absolute;
        border-top: 1px solid var(--grey4);
        left: -16px;
        top: 50%;
        width: 16px;
        height: 16px;
    }

    .single-condition-group {
        position: relative;
        // margin-bottom: 16px;
    }

    .single-condition-group::after {
        content: '';
        position: absolute;
        border-left: 1px solid var(--grey4);
        top: 20px;
        height: calc(100% - 40px);
    }

    .is-uppercase {
        text-transform: uppercase;
    }

    .and-separator {
        margin-left: 20px;
    }
    .or-separator {
        margin-left: 50px;
    }
`
